export const enum APP_STATE {
  Input = "INPUT",
  Running = "RUNNING",
}
